import { render, staticRenderFns } from "./EmptyTableMsg.vue?vue&type=template&id=1e2efead&scoped=true&"
import script from "./EmptyTableMsg.vue?vue&type=script&lang=js&"
export * from "./EmptyTableMsg.vue?vue&type=script&lang=js&"
import style0 from "./EmptyTableMsg.vue?vue&type=style&index=0&id=1e2efead&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2efead",
  null
  
)

export default component.exports